import "./App.css";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";

import { Page404 } from "./compornents/pages/Page404";
import { Login } from "./compornents/pages/login/Login";
import { Confirm } from "./compornents/pages/login/Confirm";
import { ForgotPassword } from "./compornents/pages/login/ForgotPassword";
import { Register } from "./compornents/pages/home/Register";
import { Home } from "./compornents/pages/home/Home";
import { Users } from "./compornents/pages/home/Users";
import { Groups } from "./compornents/pages/home/Groups";
import { Tenants } from "./compornents/pages/home/Tenants";
import { Tenant } from "./compornents/pages/home/Tenant";
import { useLoginUser } from "./hooks/useLoginUser";
import { memo, VFC } from "react";

export const MyRouter: VFC = memo(()=> {
  
  var {isLoggedIn} = useLoginUser();
  var {loginUser} = useLoginUser();

  return (
      <Router>
        <Routes>
          <Route path="/" element={isLoggedIn ? (<Navigate replace to="/home"/>) : (<Login />)} />
          <Route path="/login" element={isLoggedIn ? (<Navigate replace to="/home"/>) : (<Login />)} />
          <Route path="/confirm/:id" element={isLoggedIn ? (<Navigate replace to="/home"/>) : (<Confirm />)} />
          <Route path="/forgotPassword" element={isLoggedIn ? (<Navigate replace to="/home"/>) : (<ForgotPassword />)} />
          <Route path="/home" element={isLoggedIn ? (<Home />) : (<Navigate replace to="/login"/>)}>
              <Route path="regist" element={loginUser?.isAdmin ? <Register /> : (<Navigate replace to="/home"/>) } />
              <Route path="users" element={loginUser?.isAdmin ? <Users /> : (<Navigate replace to="/home"/>) } />
              <Route path="tenants" element={loginUser?.isAdmin ? <Tenants /> : (<Navigate replace to="/home"/>) } />
              <Route path="tenant/:id" element={loginUser?.isAdmin ? <Tenant /> : (<Navigate replace to="/home"/>) } />
              <Route path="groups" element={loginUser?.isAdmin ? <Groups /> : (<Navigate replace to="/home"/>) } />
          </Route>
          <Route path="/regist" element={<Register />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </Router>
  );
});

